import { IApiError } from '@/models/apiError.model';
import { IPagination } from '@/models/pagination.model';
import { TGetRedirectsQuery } from '../helpers/types';
import { IRedirect } from '@/models/redirects.model';

export const REDIRECTS_SLICE_NAME = 'redirects';

export interface RedirectsListState {
  redirectsList: {
    data: IRedirect[];
    meta: IPagination;
  } | null;
  isLoading: boolean;
  error: IApiError | null;
  query: TGetRedirectsQuery | null;
}

export const initialState: RedirectsListState = {
  redirectsList: null,
  isLoading: false,
  query: null,
  error: null,
};
